
import ProductPrice from './ProductPrice.vue';

export default class {
    constructor() {
        Vue.component('product-price', ProductPrice);
    }
}
